import { render } from "./form-time.vue?vue&type=template&id=3b44830d"
import script from "./form-time.vue?vue&type=script&lang=js"
export * from "./form-time.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__